import { format } from "date-fns";
import { FileText } from "lucide-react";
import { Card } from "@/components/ui/card";

interface Claim {
  id: string;
  claim_type: string;
  incident_date: string;
  description: string | null;
  status: string;
  created_at: string;
}

interface ClaimCardProps {
  claim: Claim;
}

export const ClaimCard = ({ claim }: ClaimCardProps) => {
  return (
    <Card className="p-6 bg-white border border-[#E5DEFF] hover:border-primary transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-4">
            <div className="p-2 bg-[#F1F0FB] rounded-lg">
              <FileText className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-primary-dark">
                {claim.claim_type}
              </h3>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize bg-blue-100 text-blue-800 mt-1">
                {claim.status}
              </span>
            </div>
          </div>
          
          <div className="space-y-2 mt-4">
            <p className="text-sm text-neutral">
              Incident Date:{" "}
              <span className="text-primary-dark">
                {claim.incident_date ? 
                  format(new Date(claim.incident_date), 'PPP p') : 
                  'Not specified'}
              </span>
            </p>
            {claim.description && (
              <p className="text-sm text-neutral">
                Description:{" "}
                <span className="text-primary-dark">
                  {claim.description}
                </span>
              </p>
            )}
            <p className="text-xs text-neutral">
              Submitted on{" "}
              <span className="text-primary-dark">
                {format(new Date(claim.created_at), 'PPP')}
              </span>
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};